import {Card} from "../../../basic/card.tsx";
import {Button} from "../../../basic/button.tsx";
import {ArrowRight, Download, UserPlus} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface QuickActionsProps {
    onDownloadClick: () => void;
    onInviteClick: () => void;
    availableSeats: number;
}

export function QuickActions({onDownloadClick, onInviteClick, availableSeats}: QuickActionsProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="grid gap-6 lg:grid-cols-2">
            <Card className="p-6 shadow-sm border-border/50 bg-primary/5">
                <div className="flex items-start gap-4">
                    <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <Download className="h-6 w-6 text-primary"/>
                    </div>
                    <div className="flex-1">
                        <h3 className="mb-1">{t('dashboard.downloadPolySun')}</h3>
                        <p className="text-muted-foreground mb-4">
                            {t('dashboard.downloadDescription')}
                        </p>
                        <Button
                            className="rounded-full"
                            onClick={onDownloadClick}
                        >
                            {t('dashboard.goToDownloads')}
                            <ArrowRight className="h-4 w-4 ml-2"/>
                        </Button>
                    </div>
                </div>
            </Card>

            <Card className="p-6 shadow-sm border-border/50 bg-primary/5">
                <div className="flex items-start gap-4">
                    <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <UserPlus className="h-6 w-6 text-primary"/>
                    </div>
                    <div className="flex-1">
                        <h3 className="mb-1">{t('dashboard.inviteTeamMembers')}</h3>
                        <p className="text-muted-foreground mb-4">
                            {t('dashboard.inviteDescription', {count: availableSeats})}
                        </p>
                        <Button
                            className="rounded-full"
                            onClick={onInviteClick}
                        >
                            {t('dashboard.manageTeam')}
                            <ArrowRight className="h-4 w-4 ml-2"/>
                        </Button>
                    </div>
                </div>
            </Card>
        </div>
    );
}